import React from 'react'
import { IndexRedirect, Route } from 'react-router'
import Main from '../containers/Main'
import Apps from '../containers/Apps'
import Talkdesk from '../containers/Talkdesk'
import Account from '../containers/Account'
import Billing from '../containers/Billing'
import Support from '../containers/Support'
import AppPage from '../containers/AppPage'
import ChannelPage from '../containers/ChannelPage'
import ChannelTypeSelector from '../containers/ChannelTypeSelector'
import Portal from '../containers/Portal'
import AppOverview from '../components/AppOverview'

import { loggedIn } from '../utils/utils'
import Login from '../containers/Login'

// onEnter callback to validate authentication in private routes
const requireAuth = (nextState, replace) => {
  if (!loggedIn()) {
    replace({ pathname: "/login" })
  }
}

export default (
  <Route name="Main" path="/" component={Main}>
    <Route name="Talkdesk" path="talkdesk" component={Talkdesk} />
    <Route path="login" component={Login}/>
    <Route name="Portal" path="" component={Portal} onEnter={requireAuth}>
      <IndexRedirect to="apps" />
      <Route name="Brands" path="apps" component={Apps} onEnter={requireAuth}>
        <Route name="AppPage" staticName={true} path=":app" component={AppPage}>
          <IndexRedirect to="overview" />
          <Route name="Overview" path="overview" component={AppOverview} onEnter={requireAuth}/>
          <Route name="Add channel" path="channeltypes/u" component={ChannelTypeSelector} onEnter={requireAuth}/>
          <Route name="Add integration" path="channeltypes/a" component={ChannelTypeSelector} onEnter={requireAuth}/>
          <Route name="Add provider" path="channeltypes/p" component={ChannelTypeSelector} onEnter={requireAuth}/>
          <Route name="ChannelPage" staticName={true} path="channels/:channel" component={ChannelPage} onEnter={requireAuth}/>
        </Route>
      </Route>
    </Route>
    <Route name="Account" path="account" component={Account} onEnter={requireAuth}/>
    <Route name="Billing" path="billing" component={Billing} onEnter={requireAuth}/>
    <Route name="Support" path="support" component={Support} onEnter={requireAuth}/>
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/index.js